<template>
    <v-content>
        <!--         Step Header         -->
      <!-- <v-row
        justify="center"
        class="mt-5 mx-3"
        style="font-size: 1.8em; font-weight: 600; color: #212121; letter-spacing: 1px;"
        no-gutters
      >
        <v-col
          class="mx-5 text-center"
        >
          START FREE TRIAL NOW!
        </v-col>
      </v-row> -->

        <!--            Content            -->
      <v-row
        justify="center"
        no-gutters
      >
        <v-col
          cols="12"
          xs="12"
          sm="10"
          md="6"
          lg="5"
          xl="4"
        >

        <!--------------------------------->
        <!-----     Select a Plan     ----->
        <!--------------------------------->
          <v-row
            class="mt-3"
            style="font-size: 1em; font-weight: 400; color: #212121; letter-spacing: 1px;"
            no-gutters
          >
            <v-col
              class="mx-3 text-center"
            >
              Select a plan for after your free trial expires
            </v-col>
          </v-row>
          
          <v-row
            class="mt-2 mx-3"
            justify="center"
            no-gutters
          >
            <v-col>
              <v-row
                no-gutters
                justify="center"
              >
                <v-card
                  class="pa-5 my-3"
                  style="width: 160px;"
                  @click.prevent="billingPlan = 'weekly'"
                  :color="billingPlan == 'weekly'? '#74cf74' : 'white'"
                >
                  <v-row
                    justify="center"
                    no-gutters
                    :style="billingPlan == 'weekly'? 'font-size: 1.3em; font-weight: 600; color: #ffffff; letter-spacing: 1px;' : 'font-size: 1.3em; font-weight: 600; color: #424242; letter-spacing: 1px;'"
                  >
                      Weekly
                  </v-row>
                  <v-row
                    justify="center"
                    no-gutters
                    :style="billingPlan == 'weekly'? 'font-size: 1.0em; font-weight: 500; color: #ffffff; letter-spacing: 1px;' : 'font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;'"
                  >
                    $2
                  </v-row>
                  <v-row
                    justify="center"
                    no-gutters
                    :style="billingPlan == 'weekly'? 'font-size: 0.7em; font-weight: 500; color: #ffffff; letter-spacing: 1px;' : 'font-size: 0.7em; font-weight: 500; color: #424242; letter-spacing: 1px;'"
                  >
                    ($2.00/menu)
                  </v-row>
                </v-card>
              </v-row>
            </v-col>
            <v-col
              class = "mx-3"
            >
              <v-row
                no-gutters
                justify="center"
              >
                <v-card
                  class="pa-5 my-3"
                  style="width: 160px;"
                  @click.prevent="billingPlan = 'monthly'"
                  :color="billingPlan == 'monthly'? '#74cf74' : 'white'"
                >
                  <v-row
                    justify="center"
                    no-gutters
                    :style="billingPlan == 'monthly'? 'font-size: 1.3em; font-weight: 600; color: #ffffff; letter-spacing: 1px;' : 'font-size: 1.3em; font-weight: 600; color: #424242; letter-spacing: 1px;'"
                  >
                      Monthly
                  </v-row>
                  <v-row
                    justify="center"
                    no-gutters
                    :style="billingPlan == 'monthly'? 'font-size: 1.0em; font-weight: 500; color: #ffffff; letter-spacing: 1px;' : 'font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;'"
                  >
                    $6
                  </v-row>
                  <v-row
                    justify="center"
                    no-gutters
                    :style="billingPlan == 'monthly'? 'font-size: 0.7em; font-weight: 500; color: #ffffff; letter-spacing: 1px;' : 'font-size: 0.7em; font-weight: 500; color: #424242; letter-spacing: 1px;'"
                  >
                    ($1.40/menu)
                  </v-row>
                </v-card>
              </v-row>
            </v-col>
            <v-col
              class = "mx-3"
            >
              <v-row
                no-gutters
                justify="center"
              >
                <v-card
                  class="pa-5 my-3"
                  style="width: 160px;"
                  @click.prevent="billingPlan = 'annual'"
                  :color="billingPlan == 'annual' ? '#74cf74' : 'white'"
                >
                  <v-row
                    justify="center"
                    no-gutters
                    :style="billingPlan == 'annual'? 'font-size: 1.3em; font-weight: 600; color: #ffffff; letter-spacing: 1px;' : 'font-size: 1.3em; font-weight: 600; color: #424242; letter-spacing: 1px;'"
                  >
                      Annual
                  </v-row>
                  <v-row
                    justify="center"
                    no-gutters
                    :style="billingPlan == 'annual'? 'font-size: 1.0em; font-weight: 500; color: #ffffff; letter-spacing: 1px;' : 'font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;'"
                  >
                    $52
                  </v-row>
                  <v-row
                    justify="center"
                    no-gutters
                    :style="billingPlan == 'annual'? 'font-size: 0.7em; font-weight: 500; color: #ffffff; letter-spacing: 1px;' : 'font-size: 0.7em; font-weight: 500; color: #424242; letter-spacing: 1px;'"
                  >
                    ($1.00/menu)
                  </v-row>
                </v-card>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            style="font-size: .9em; font-weight: 400; color: #212121; letter-spacing: 1px;"
            justify="center"
            no-gutters
          >
             <v-col
              class = "mx-3 text-center"
            >
              You can cancel anytime to stop payment
            </v-col>
          </v-row>
          <v-row
            class="mb-8"
            style="font-size: .8em; font-weight: 400; color: #212121; letter-spacing: 1px;"
            justify="center"
            no-gutters
          >
             <v-col
              class = "mx-3 text-center"
            >
              First payment is scheduled for {{firstBilledDate}}
            </v-col>
          </v-row>

        <!--------------------------------->
        <!--       What's Included       -->
        <!--------------------------------->
          <v-row
            justify="center"
            class="mt-2 mx-3"
            style="font-size: 1.3em; font-weight: 600; color: #212121; letter-spacing: 1px;"
            no-gutters
          >
            <v-col
              class="mx-5 text-center"
            >
              What you get each week
            </v-col>
          </v-row>
          <v-row
            justify="center"
            class="mt-3"
            no-gutters
          >
            <v-col
              class = "mx-3"
              cols="12"
              xs="12"
              sm="12"
              md="12"
              lg="11"
              xl="10"
            >

              <v-row
                no-gutters
                style="font-size: 1.0em; font-weight: 600; color: #212121; letter-spacing: 1px;"
              >
                <v-col
                  class="mb-1 text-center"
                >
                  Menu
                </v-col>
              </v-row>
              <div>
                <v-row
                  v-for="(item,i) in weeklyBenefit1"
                  :key="i"
                  no-gutters
                >
                  <v-col
                    class="ml-5 shrink mr-1"
                  >
                    <v-icon
                      color="#74cf74"
                    >
                      done
                    </v-icon>
                  </v-col>
                  <v-col>
                    {{item.name}}
                  </v-col>
                </v-row>
              </div>

              <v-row
                no-gutters
                style="font-size: 1.0em; font-weight: 600; color: #212121; letter-spacing: 1px;"
                class="mt-2"
              >
                <v-col
                  class="mb-1 text-center"
                >
                  Shopping List
                </v-col>
              </v-row>

              <div>
                <v-row
                  v-for="(item,i) in weeklyBenefit2"
                  :key="i"
                  no-gutters
                >
                  <v-col
                    class="ml-5 shrink mr-1"
                  >
                    <v-icon
                      color="#74cf74"
                    >
                      done
                    </v-icon>
                  </v-col>
                  <v-col>
                    {{item.name}}
                  </v-col>
                </v-row>
              </div>
              
            </v-col>
          </v-row>
          <v-row
            no-gutters
            style="font-size: 0.6em; font-weight: 600; color: #212121; letter-spacing: 1px;"
            class="mb-2"
          >
            <v-col
              class="mt-2 mb-5 text-center"
            >
              *availability varies by market
            </v-col>
          </v-row>

        <!--------------------------------->
        <!--         Payment Info        -->
        <!--------------------------------->
          <v-row
            v-if = "billingPlan != null"
            class="mb-8"
            no-gutters
          >
            <v-col
              class="mx-5 text-center"
            >
              Payment Info Placeholder
            </v-col>
          </v-row>

        <!--------------------------------->
        <!--          Navigation         -->
        <!--------------------------------->
          <v-row
            no-gutters
            class="mx-5 mb-12"
            justify="center"
          >
            <v-btn
              class="btn2 ml-2"
              color = #74cf74
              @click="goToApp"
              :disabled="disableStep6Next"
            >
              Take me to my first menu!
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <!-- <v-row
        style="font-size: .9em; font-weight: 400; color: #212121; letter-spacing: 1px;"
        no-gutters
      >
        <v-col
          v-if="billingPlan != null"
          class="mx-3 mt-2 text-center"
        >
          Your first payment of ${{firstBillAmount}} will be processed on {{firstBilledDate}}.
          <br>
          Recurring payments will then be processed {{billingFrequency}}.
        </v-col>
      </v-row> -->
    </v-content>
</template>

<script>
    export default {

        data: () => ({
            billingPlan: null,
            weeklyBenefit1: [
              {
                name: 'Generated automatically for you'
              },
              {
                name: 'Recipes that fit your diet'
              },
              {
                name: 'Personalized to your likes'
              },
              {
                name: 'Recipes scaled to fit your family'
              },
              {
                name: 'Per person portions to hit daily calories'
              },
              {
                name: 'Macros planned for each person'
              },
              {
                name: 'Leftovers automatically scheduled'
              },
            ],
          weeklyBenefit2: [
            {
                row: 1,
                name: 'Automatically generated'
              },
              {
                row: 2,
                name: 'Option to add extras'
              },
              {
                row: 3,
                name: 'Option for curbside pickup*'
              },
              {
                row: 4,
                name: 'Option for grocery delivery*'
              },
          ]
        }),

        methods: {
            goToApp() {
              this.$store.dispatch('data/updateAccountStatus','active');
              this.$router.push('/menu');
              this.stepper = 1;
            }
        },

        computed: {
            stepper: {
                get() {
                    return this.$store.getters['data/stepper'];
                },
                set(value) {
                    this.$store.dispatch('data/updateStepper',value);
                }
            },

            disableStep6Next() {
                if (this.billingPlan == null | this.billingPlan == ''){
                    return true
                } else {
                    return false
                }
            },

            today() {
              let date = new Date();
              let cleanDate = (date.getMonth() + 1) + "/" + (date.getDate()) + "/" + (date.getFullYear());
              return cleanDate
            },

            trialEndDate() {
              let date = new Date();
              date.setDate(date.getDate() + (13 - date.getDay()));
              let cleanDate = (date.getMonth() + 1) + "/" + (date.getDate()) + "/" + (date.getFullYear());
              return cleanDate
            },

            firstBilledDate() {
              let date = new Date();
              date.setDate(date.getDate() + (14 - date.getDay()));
              let cleanDate = (date.getMonth() + 1) + "/" + (date.getDate()) + "/" + (date.getFullYear());
              return cleanDate
            },

            firstBillAmount() {
              let amount = null;

              if (this.billingPlan == 'annual'){
                amount = 52
              } else if (this.billingPlan == 'monthly'){
                amount = 6
              } else if (this.billingPlan == 'weekly'){
                amount = 2
              } 
              return amount
            },
            
            billingFrequency() {
              let response = null;

              if (this.billingPlan == 'annual'){
                response = 'annually'
              } else if (this.billingPlan == 'monthly'){
                response = 'monthly'
              } else if (this.billingPlan == 'weekly'){
                response = 'weekly'
              } 
              return response
            },

        },
    }
</script>

<style scoped>
  .btn2 {
    font-family: "Noto Serif TC", serif;
    font-size: 0.9em;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }

  .btn3 {
    font-size: 0.9em;
    width: 100%;
    min-height: 48px;
    font-weight: 400;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: #74cf74 !important;
    font-weight: 600;
  }
</style>

